import React from "react";
import { Dialog, DialogTrigger, Modal } from "react-aria-components";
import { t } from "ttag";

import { ServerCmsContextProcessorsCountryPage } from "@reactivated";

import { ButtonPrimary, Clickable } from "../Clickables";
import { Select as FormSelect, SelectItem } from "../Forms/Select";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

interface Props {
    isOpen?: boolean;
    onOpenChange?: (isOpen: boolean) => void;
    countries: ServerCmsContextProcessorsCountryPage[];
    suggestedLocale: string | null;
    onSubmit?: (selectedLocale: string) => void;
}

export const SwitchLocaleModal = ({
    isOpen,
    onOpenChange,
    countries,
    suggestedLocale,
    onSubmit,
}: Props) => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const selectedLocale = formData.get("country");

        if (typeof selectedLocale !== "string" || !onSubmit) return;
        onSubmit(selectedLocale);
    };

    return (
        <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
            <Modal className={styles.modal}>
                <Dialog className={styles.dialog}>
                    {({ close }) => (
                        <>
                            <Clickable
                                className={styles.overlay}
                                onPress={close}
                                aria-hidden="true"
                                tabIndex={-1}
                            />
                            <div className={styles.content}>
                                <Clickable
                                    className={styles.close}
                                    onPress={close}
                                >
                                    <Svg
                                        name="x"
                                        visuallyHiddenText={t`Close`}
                                    />
                                </Clickable>
                                <h2 className={styles.title}>
                                    {t`It looks like you're browsing from a different location`}
                                </h2>
                                <p className={styles.subtitle}>
                                    {t`For the best site and content experience, please update your location`}
                                </p>
                                <form onSubmit={handleSubmit}>
                                    <div className={styles.selectContainer}>
                                        <FormSelect
                                            className={styles.select}
                                            label={t`Select Country`}
                                            labelVisible={false}
                                            theme="form"
                                            name="country"
                                            defaultSelectedKey={
                                                suggestedLocale ?? undefined
                                            }
                                            items={countries.sort((a, b) =>
                                                a.locale_autonym.localeCompare(
                                                    b.locale_autonym,
                                                ),
                                            )}
                                        >
                                            {(country) => (
                                                <SelectItem
                                                    id={country.language_code}
                                                >
                                                    {country.locale_autonym}
                                                </SelectItem>
                                            )}
                                        </FormSelect>

                                        <ButtonPrimary
                                            className={styles.continueButton}
                                            type="submit"
                                        >
                                            {t`Continue`}
                                        </ButtonPrimary>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                </Dialog>
            </Modal>
        </DialogTrigger>
    );
};
